interface ResponsiveImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /** Desktop/tablet image URL (default) */
  src: string;
  /** Mobile image URL (served on screens ≤ 768px) */
  mobileSrc?: string | null;
  /** Sizes attribute for responsive image hints */
  sizes?: string;
}

/**
 * Renders a <picture> element with a mobile-optimised source
 * when a separate mobile image URL is available.
 */
const ResponsiveImage = ({
  src,
  mobileSrc,
  sizes,
  loading = "lazy",
  decoding = "async",
  alt = "",
  ...props
}: ResponsiveImageProps) => {
  if (!mobileSrc) {
    return <img src={src} sizes={sizes} loading={loading} decoding={decoding} alt={alt} {...props} />;
  }

  return (
    <picture>
      <source media="(max-width: 768px)" srcSet={mobileSrc} />
      <img src={src} sizes={sizes} loading={loading} decoding={decoding} alt={alt} {...props} />
    </picture>
  );
};

export default ResponsiveImage;
